import React from 'react'
import { DonationFormBLockClassNames } from './donationFormBlock.state'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { expandableBlockClasses } from '../expandableBlock/expandableBlock.layout'
import { SharingLayout } from '../../../header/pageHeader/sharing.layout'
import { ReadSpeaker } from '../../../../readspeaker/readspeaker.widget'
import { State, renderReadSpeaker } from '../../../cmsPage.widget'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'

export const donationBlockClasses: DonationFormBLockClassNames = {
  // DEFAULTS
  block: 'block block--donation',
  inview: 'inview',

  // BLOCK SPECIFIC
}

export const DonationBlockLayout = {
  Wrapper:(html:JSX.Element, header?:JSX.Element) => <>
    {header}
    <div className="block__inner ls-container--l">
      <div className="block__layout">
        {html}
      </div>
    </div>
  </>,
  Form:(p:{html: JSX.Element, showHeader?:boolean, title:string, step:number}) =>
    <div className='donation ls-container ls-gutter ls-spacing--s'>
      <div className='donation__inner'>
        <div className={`donation__form step-${p.step < 2 ? 'initial' : 'x'}`}>
          {p.showHeader && p.title ? <h2 id={slugify(htmlDecode(p.title))} className='donation__title title--s'>{p.title}</h2> : null}
          {p.html}
        </div>
      </div>
    </div>,
  Extras:(p:{expandables: JSX.Element, text:string, state: State}) =>
    <div className='block__wrap'>
      <SharingLayout.Wrap>
        {renderReadSpeaker(p.state) == true && <ReadSpeaker keyId="a1" encodedUrl={encodeURI(window.location.href)} readElementId={'a11y-main'} />}
        <SharingLayout.Button />
        <SharingLayout.Popup />
      </SharingLayout.Wrap>

      <section className={getClassNameModern(expandableBlockClasses, "block") + " " + getClassNameModern(expandableBlockClasses, "inview")}>
        <div className={getClassNameModern(expandableBlockClasses, "inner")}>
          <header className={getClassNameModern(expandableBlockClasses, "header")}>
            <p className={getClassNameModern(expandableBlockClasses, "intro")} dangerouslySetInnerHTML={{ __html: p.text }} />
          </header>
          <div className={getClassNameModern(expandableBlockClasses, "content")}>
            {p.expandables}
          </div>
        </div>
      </section>
    </div>
}
